<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part">Part One</h1>
<p class="center"><img alt="" src="OEBPS/images/9780312382582_clogo1.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_p01_r1.vue?11055358